export const MAIN_ROUTE = "/"
export const EXPERT_ROUTE = "/expert_course"
export const AUTH_ROUTE = "/signin"
export const FORGOT_PASSWORD_ROUTE = "/forgot_password"
export const USER_ROUTE = "/user"
export const STATEMENT_ROUTE = "/user/statement"
export const COURSE_ROUTE = "/user/course"
export const TEST_ROUTE = "/user/course/test/:id"
export const LECTION_ROUTE = "/user/course/lection/:id"
export const VIDEO_ROUTE = "/user/course/video"
export const PRACTICAL_WORK_ROUTE = "/user/course/practical_work"
export const FINISH_TEST_ROUTE = "/user/course/finish_test"
export const CHAR_PAGE_ROUTE = "/admin/chat/:id"
export const CHAT_USERS_PAGE_ROUTE = "/admin/chat/"
export const USER_CHAT_ROUTE = "/user/chat"
export const ADMIN_ROUTE = "/admin"
export const ADMIN_ADMINISTRATORS_ROUTE = "/admin/administrators/"
export const ADMIN_PROGRAMS_ROUTE = "/admin/programs"
export const ADMIN_PRACTICAL_WORKS_ROUTE = "/admin/practical_works"
export const ADMIN_VIEW_PRACTICAL_WORKS_ROUTE = "/admin/view_practical_work/"
export const ADMIN_ONE_PRACTICAL_WORKS_ROUTE = "/admin/practical_works/:id"
export const ADMIN_VIEW_PROGRAM= "/admin/programs/:id"
export const ADMIN_VIEW_TEST= "/admin/programs/test/:id"
export const ADMIN_VIEW_VIDEO= "/admin/programs/video"
export const ADMIN_VIEW_LECTION= "/admin/programs/lection/:id"
export const MAKE_PROGRAM_ROUTE = "/admin/programs/new/:id"
export const ADMIN_LISTENERS_ROUTE = "/admin/listeners"
export const ADMIN_APPLICATIONS_ROUTE = "/admin/applications"
export const ADMIN_REGISTRATE_USER = "/admin/listeners/new_listener"
export const ADMIN_USER_ROUTE = "/admin/listeners/:id"
export const ADMIN_CHANGE_USER= "/admin/listeners/new_listener/:id"
export const ADMIN_REGISTRATE_ADMIN= "/admin/administrators/new_admin"
export const ADMIN_STATEMENT_USER= "/admin/listeners/statement/:id"
export const ADMIN_DOCUMENTS_ROUTE = "/admin/documents/"

